// v3/design-system/primitives/skeleton.tsx — Loading skeleton
// Shimmer animation via Tailwind animate-pulse.
// Zero imports from v1/v2.

import * as React from 'react';

import { cn } from '../utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}

export { Skeleton };
